(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHome = (root) => {
    if (!root || root.dataset.tpReady === 'true') return;
    root.dataset.tpReady = 'true';

    const panels = Array.from(root.querySelectorAll('[data-tp-panel]'));
    if (!panels.length) return;

    const setActive = () => {
      const mid = window.innerHeight * 0.45;
      let current = panels[0];
      panels.forEach((panel) => {
        const rect = panel.getBoundingClientRect();
        if (rect.top <= mid && rect.bottom >= mid) current = panel;
      });
      panels.forEach((panel) => panel.classList.toggle('is-active', panel === current));
    };

    const updateDepth = () => {
      if (reduceMotion) return;
      panels.forEach((panel) => {
        const media = panel.querySelector('[data-tp-depth]');
        if (!media) return;
        /* Image-text banners stay 100% width with no crop/transform */
        if (panel.classList.contains('tp-panel--image-text') || media.classList.contains('tp-media--safe')) {
          media.style.transform = 'none';
          return;
        }
        const depth = Number(media.getAttribute('data-tp-depth') || 0.2);
        const rect = panel.getBoundingClientRect();
        const progress = (window.innerHeight / 2 - (rect.top + rect.height / 2)) / window.innerHeight;
        const shift = Math.max(-8, Math.min(8, progress * depth * 100));
        media.style.transform = `translate3d(0, ${shift}%, 0) scale(1.08)`;
      });
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setActive();
        updateDepth();
        ticking = false;
      });
    };

    setActive();
    updateDepth();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  };

  const boot = () => {
    document.querySelectorAll('[data-tp-home]').forEach(initHome);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-tp-home]') || event.target.closest?.('[data-tp-home]');
    if (root) {
      root.dataset.tpReady = 'false';
      initHome(root);
    } else {
      boot();
    }
  });
})();
